// extracted by mini-css-extract-plugin
export default {"tip":"tip___iLOOa","icon":"icon___XuK89","text":"text___t3tNN"};